const ticketType = {
  tab: {
    main: "Type",
  },
  search: {
    name: "Nom"
  },
  new: {
    title: "Nouveau type de ticket"
  }
};

export default ticketType;
